module.exports = __webpack_public_path__ + "img/car_engine.eb38d9c9.svg";